export const getPromotionDetailRouteId = (id: unknown) =>
  id === undefined || id === null ? '' : String(id).trim();
